import {apiURl} from './apiconfig'

export const login = ({payload}) => {
  const LOGIN_API_ENDPOINT = apiURl + 'auth/login';
  const parameters = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload.user)
  };

  return fetch(LOGIN_API_ENDPOINT, parameters)
  .then(response => {
      const statusCode = response.status;
      const data = response.json();
  return Promise.all([statusCode, data]);
  })
  .then(([res, data]) => {
      return [res, data];
  })
  .catch(error => {
      return error;
  });
};

export const updateUserDataRequest= (token) => {
  const GET_USER_ENDPOINT = apiURl + 'auth/getUser';
  const parameters = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization' : 'Bearer ' + token,
    }
  };

  return fetch(GET_USER_ENDPOINT, parameters)
  .then(response => {
      const statusCode = response.status;
      const data = response.json();
      return Promise.all([statusCode, data]);
  })
  .then(([res, data]) => {
      return [res, data];
  })
  .catch(error => {
      return error;
  });
};